/** True when running the Vite server on localhost (`npm run dev`), not unit tests. */
function isLocalApiProxyEnabled(): boolean {
  return import.meta.env.DEV && !import.meta.env.VITEST;
}

/** Summit API gateway origin for browser requests. */
export function apiBaseUrl(): string {
  if (isLocalApiProxyEnabled()) {
    return "";
  }
  return import.meta.env.VITE_API_BASE_URL;
}

export function apiV1BaseUrl(): string {
  return `${apiBaseUrl()}/v1`;
}

export function pairingApiBaseUrl(): string {
  if (isLocalApiProxyEnabled()) {
    return "";
  }
  return import.meta.env.VITE_PAIRING_API_BASE_URL;
}
